import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

export default class reportTokenApi {
  static get(params, headers) {
    const conf = getApiConfig();
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    const url = `${conf.accountUrlV2}/oauth/reports-token`;
    return axios.post(url, params, config).then(res => res.data);
  }
}
